/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Label from "../Label";
import { useController } from "react-hook-form";
import { StyledFormField } from "./StyledFormField";
import { useTranslate } from "../../../hooks/useTranslate";

const TextareaField = React.forwardRef(
  ({ name, control, label, required = false, defaultValue, validationRules = {}, placeholder, ...props }, ref) => {
    const { _t } = useTranslate();
    const { field, fieldState } = useController({
      name,
      control,
      rules: {
        required: required ? "error_value_is_empty" : undefined,
        ...validationRules,
      },
      defaultValue: defaultValue || "",
    });

    return (
      <>
        {label ? (
          <Label name={name} required={required}>
            {label}
          </Label>
        ) : undefined}
        <StyledFormField.Textarea
          {...field}
          id={name}
          $error={fieldState.error}
          aria-invalid={!!fieldState.error}
          aria-required={required || undefined}
          aria-describedby={fieldState.error ? `${name}-error` : undefined}
          ref={ref}
          rows={5}
          placeholder={_t(placeholder)}
          {...props}
        />
      </>
    );
  }
);

export default TextareaField;
